module.exports = __webpack_public_path__ + "static/media/s0.ba6a8dd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/marmalade/s0.jpg
// module id = 291
// module chunks = 0